
// tabs start
document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll('[data-tabs]').forEach(section => {

    const buttons = section.querySelectorAll('[data-tab-target]');
    const contents = section.querySelectorAll('[data-tab-content]');

    buttons.forEach(button => {

      button.addEventListener('click', () => {

        const target = button.getAttribute('data-tab-target');

        buttons.forEach(btn => {
          btn.removeAttribute('data-active');
        });

        contents.forEach(content => {
          content.removeAttribute('data-active');
        });

        button.setAttribute('data-active', 'true');

        const activeContent = section.querySelector(
          `[data-tab-content="${target}"]`
        );

        if (activeContent) {
          activeContent.setAttribute('data-active', 'true');
        }

      });

    });

  });

});


// Accordion script start 
function initAccordion(scope = document) {
  const triggers = scope.querySelectorAll('[data-toggle="collapse"]');

  if (!window.__accordionActiveByParent) {
    window.__accordionActiveByParent = new Map();
  }

  const activeByParent = window.__accordionActiveByParent;

  triggers.forEach(trigger => {
    if (trigger.dataset.accordionBound === 'true') return;

    const targetSel = trigger.dataset.target;
    if (!targetSel) return;

    const content = scope.querySelector(targetSel) || document.querySelector(targetSel);
    if (!content) return;

    trigger.collapseTarget = content;
    trigger.dataset.accordionBound = 'true';

    const parentSel = content.dataset.parent || null;

    if (content.classList.contains('is-active')) {
      if (parentSel) activeByParent.set(parentSel, trigger);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      toggleAccordion(trigger, activeByParent);
    });

    content.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'height' && content.classList.contains('is-active')) {
        content.style.height = 'auto';
      }
    });
  });
}

function toggleAccordion(trigger, activeByParent) {
  const content = trigger.collapseTarget;
  if (!content) return;

  const parentSel = content.dataset.parent || null;

  if (content.classList.contains('is-active')) {
    closeAccordion(trigger);
    if (parentSel && activeByParent.get(parentSel) === trigger) {
      activeByParent.delete(parentSel);
    }
    return;
  }

  if (parentSel) {
    const activeToggle = activeByParent.get(parentSel);
    if (activeToggle && activeToggle !== trigger) {
      closeAccordion(activeToggle);
    }
    activeByParent.set(parentSel, trigger);
  }

  openAccordion(trigger);
}

function closeAccordion(trigger) {
  const content = trigger.collapseTarget;
  if (!content) return;

  content.style.height = content.scrollHeight + 'px';

  requestAnimationFrame(() => {
    content.style.height = '0px';
    content.classList.remove('is-active');
  });

  trigger.classList.remove('is-active');
}

function openAccordion(trigger) {
  const content = trigger.collapseTarget;
  if (!content) return;

  content.style.height = '0px';
  content.classList.add('is-active');
  trigger.classList.add('is-active');

  requestAnimationFrame(() => {
    content.style.height = content.scrollHeight + 'px';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initAccordion();
});

// ========================================
// SWIPER SLDIER START
// ========================================
// data-swiper call
// data-desktop = string
// data-laptop = string
// data-tablet = string
// data-mobile = string
// data-slider-from = string  650 / 992
// data-space= = string
// data-mobile-space= = string
// data-speed = string
// data-loop= = boolean
// data-autoplay = boolean
// data-delay = string
// data-navigation= = boolean
// data-pagination = boolean
// data-item-auto= string
// data-scrollbar= boolean

function initResponsiveSwiper(slider) {
  if (!slider) return;

  const sliderFrom = parseInt(slider.dataset.sliderFrom) || null;
  const autoplay = slider.dataset.autoplay === "true";
  const delay = parseInt(slider.dataset.delay) || 0;
  const loop = slider.dataset.loop === "true";
  const speed = parseInt(slider.dataset.speed) || 400;
  const space = parseInt(slider.dataset.space) || 0;
  const mobileSpace = parseInt(slider.dataset.mobileSpace) || space;
  const desktop = parseFloat(slider.dataset.desktop) || 4;
  const laptop = parseFloat(slider.dataset.laptop) || 3;
  const tablet = parseFloat(slider.dataset.tablet) || 2;
  const mobile = parseFloat(slider.dataset.mobile) || 1;
  const navigation = slider.dataset.navigation === "true";
  const pagination = slider.dataset.pagination === "true";
  const itemAuto = slider.dataset.itemAuto === "true";
  const scrollbar = slider.dataset.scrollbar === "true";
  const scrollbarEl = slider.querySelector(".swiper-scrollbar");
  const paginationType = slider.dataset.paginationType || "bullets";
  const touchMove = slider.dataset.touchMove === "false" ? false : true;

  const nextBtn = slider.querySelector(".swiper-button-next");
  const prevBtn = slider.querySelector(".swiper-button-prev");
  const paginationEl = slider.querySelector(".swiper-pagination");
  const arrowWrapper = slider.querySelector(".custom-arrow");



  const shouldEnableSlider = !sliderFrom || window.innerWidth < sliderFrom;

  if (slider.swiper) {
    slider.swiper.destroy(true, true);
  }

  if (shouldEnableSlider) {
    const totalSlides = slider.querySelectorAll(".swiper-slide").length;
    const currentSlidesPerView =
      window.innerWidth >= 1200 ? desktop :
      window.innerWidth >= 992 ? laptop :
      window.innerWidth >= 650 ? tablet :
      mobile;

    const enableLoop = loop && totalSlides > currentSlidesPerView;

    new Swiper(slider, {
      loop: enableLoop,
      speed: speed,
      spaceBetween: space,
      allowTouchMove: touchMove,
      simulateTouch: touchMove,
      touchRatio: touchMove ? 1 : 0,
      slidesPerView: itemAuto ? 'auto' : mobile,
      breakpoints: itemAuto ? {
        0: {
          spaceBetween: mobileSpace
        },
        650: {
          spaceBetween: space
        },
        992: {
          spaceBetween: space
        },
        1200: {
          spaceBetween: space
        }
      } : {
        0: {
          slidesPerView: mobile,
          spaceBetween: mobileSpace
        },
        650: {
          slidesPerView: tablet,
          spaceBetween: space
        },
        992: {
          slidesPerView: laptop,
          spaceBetween: space
        },
        1200: {
          slidesPerView: desktop,
          spaceBetween: space
        }
      },
      autoplay: autoplay
        ? {
            delay: delay,
            disableOnInteraction: false
          }
        : false,
      navigation: navigation && nextBtn && prevBtn
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn
          }
        : false,
      pagination: pagination && paginationEl
        ? {
            el: paginationEl,
            clickable: true, 
          }
        : false,
        scrollbar: scrollbar && scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true
          }
        : false,
      observer: true,
      observeParents: true,
      watchOverflow: true
    });

    if (navigation) {
      if (arrowWrapper) arrowWrapper.style.display = "";
      if (nextBtn) {
        nextBtn.style.display = "";
        nextBtn.style.pointerEvents = "";
        nextBtn.style.opacity = "";
        nextBtn.removeAttribute("disabled");
      }
      if (prevBtn) {
        prevBtn.style.display = "";
        prevBtn.style.pointerEvents = "";
        prevBtn.style.opacity = "";
        prevBtn.removeAttribute("disabled");
      }
    }

    if (paginationEl) {
      paginationEl.style.display = "";
    }
    if (scrollbarEl) {
      scrollbarEl.style.display = "";
    }
  } else {
    if (navigation) {
      if (arrowWrapper) arrowWrapper.style.display = "none";

      if (nextBtn) {
        nextBtn.setAttribute("disabled", "disabled");
        nextBtn.style.pointerEvents = "none";
        nextBtn.style.opacity = "0.4";
        nextBtn.style.display = "none";
      }

      if (prevBtn) {
        prevBtn.setAttribute("disabled", "disabled");
        prevBtn.style.pointerEvents = "none";
        prevBtn.style.opacity = "0.4";
        prevBtn.style.display = "none";
      }
    }

    if (paginationEl) {
      paginationEl.style.display = "none";
    }
    if (scrollbarEl) {
      scrollbarEl.style.display = "none";
    }
  }
}

function handleResponsiveSwipers(container = document) {
  container.querySelectorAll(".swiper[data-swiper]").forEach(function (slider) {
    initResponsiveSwiper(slider);
  });
}

// Initial page load
document.addEventListener("DOMContentLoaded", function () {
  handleResponsiveSwipers();

  // Watch async-loaded sections like product recommendations
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (node.matches(".swiper[data-swiper]")) {
          initResponsiveSwiper(node);
        } else if (node.querySelector && node.querySelector(".swiper[data-swiper]")) {
          handleResponsiveSwipers(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Resize debounce
let swiperResizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(swiperResizeTimer);
  swiperResizeTimer = setTimeout(function () {
    handleResponsiveSwipers();
  }, 150);
});

// Shopify Theme Editor support
document.addEventListener("shopify:section:load", function (event) {
  handleResponsiveSwipers(event.target);
});

document.addEventListener("shopify:section:reorder", function (event) {
  handleResponsiveSwipers(event.target);
});

document.addEventListener("shopify:block:select", function (event) {
  const section = event.target.closest(".shopify-section");
  if (section) {
    handleResponsiveSwipers(section);
  }
});
// swiper js end 

// video popup script
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("reviewVideoPopup");
  const frame = document.getElementById("reviewVideoFrame");
  if (!popup || !frame) return;

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".video-trigger");
    if (!btn) return;

    const videoType = btn.dataset.videoType || "";
    const uploadSrc = btn.dataset.videoSrc || "";
    const url = btn.dataset.videoUrl || "";
    const videoLayout = btn.dataset.videoLayout || "portrait";
    let html = "";

    popup.classList.remove("is-landscape", "is-portrait");
    popup.classList.add(videoLayout === "portrait" ? "is-portrait" : "is-landscape");

    if (videoType === "upload" && uploadSrc) {
      html = `
        <video class="popup-video" autoplay playsinline controls>
          <source src="${uploadSrc}" type="video/mp4">
        </video>
      `;
    } else if (videoType === "url" && url) {
      if (url.includes("youtube") || url.includes("youtu.be")) {
        let id = "";

        if (url.includes("v=")) {
          id = url.split("v=")[1].split("&")[0];
        } else {
          id = url.split("/").pop().split("?")[0];
        }

        html = `
          <iframe
            src="https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1&rel=0"
            allow="autoplay; encrypted-media"
            allowfullscreen>
          </iframe>
        `;
      } else if (url.includes("vimeo")) {
        const id = url.split("/").pop().split("?")[0];
        html = `
          <iframe
            src="https://player.vimeo.com/video/${id}?autoplay=1&muted=1"
            allow="autoplay; fullscreen"
            allowfullscreen>
          </iframe>
        `;
      } else {
        html = `
          <video class="popup-video" autoplay muted playsinline controls>
            <source src="${url}" type="video/mp4">
          </video>
        `;
      }
    } else {
      return;
    }

    frame.innerHTML = html;
    popup.classList.add("active");
    document.body.classList.add("overflow-hidden");

    const video = frame.querySelector(".popup-video");
    if (video) {
      video.muted = true;
      video.playsInline = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.log("Autoplay blocked:", error);
        });
      }
    }
  });

  function closeVideo() {
    const video = frame.querySelector(".popup-video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    popup.classList.remove("active", "is-landscape", "is-portrait");
    frame.innerHTML = "";
    document.body.classList.remove("overflow-hidden");
  }

  const overlay = popup.querySelector(".review-video-popup__overlay");
  const closeBtn = popup.querySelector(".review-video-popup__close");

  if (overlay) overlay.addEventListener("click", closeVideo);
  if (closeBtn) closeBtn.addEventListener("click", closeVideo);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popup.classList.contains("active")) {
      closeVideo();
    }
  });
});


function updateScrollbarWidth() {
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth;

  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${scrollbarWidth}px`
  );
}

updateScrollbarWidth();
window.addEventListener('resize', updateScrollbarWidth);

/* Nabia desktop navigation: open dropdown/mega menu on hover, parent click navigates. */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const timers = new WeakMap();

  document.addEventListener('mouseover', (event) => {
    if (!desktop.matches) return;
    const details = event.target.closest?.('.header__inline-menu details[data-parent-menu-url]');
    if (!details || details.contains(event.relatedTarget)) return;
    const timer = timers.get(details);
    if (timer) clearTimeout(timer);
    const nav = details.closest('.header__inline-menu');
    nav?.querySelectorAll('details[data-parent-menu-url][open]').forEach((item) => {
      if (item !== details) item.removeAttribute('open');
    });
    details.setAttribute('open', '');
  });

  document.addEventListener('mouseout', (event) => {
    if (!desktop.matches) return;
    const details = event.target.closest?.('.header__inline-menu details[data-parent-menu-url]');
    if (!details || details.contains(event.relatedTarget)) return;
    const timer = setTimeout(() => details.removeAttribute('open'), 140);
    timers.set(details, timer);
  });

  document.addEventListener('click', (event) => {
    if (!desktop.matches) return;
    const summary = event.target.closest?.('.header__inline-menu details[data-parent-menu-url] > summary');
    if (!summary) return;
    const details = summary.parentElement;
    const url = details?.dataset.parentMenuUrl;
    if (!url || url === '#') return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(url);
  }, true);
})();

/* Nabia: product card hover video + PDP subtotal */
(() => {
  const money = (cents,currency) => { try { return new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:currency||window.Shopify?.currency?.active||'INR',maximumFractionDigits:2}).format(cents/100); } catch(e){ return (cents/100).toFixed(2); } };
  const updateSubtotal = (scope) => {
    const wrapper=scope?.closest?.('.product-action-wrapper')||scope||document;
    const el=wrapper.querySelector?.('[data-product-subtotal]'), qty=wrapper.querySelector?.('input[name="quantity"]');
    if(!el||!qty) return;
    const out=el.querySelector('[data-product-subtotal-value]');
    if(out) out.textContent=money(Number(el.dataset.unitPrice||0)*Math.max(0,Number(qty.value||0)),el.dataset.currency);
  };
  document.addEventListener('mouseover',e=>{const c=e.target.closest('.card-wrapper');const v=c?.querySelector('.card-hover-video');if(v)v.play().catch(()=>{});});
  document.addEventListener('mouseout',e=>{const c=e.target.closest('.card-wrapper');if(!c||(e.relatedTarget&&c.contains(e.relatedTarget)))return;const v=c.querySelector('.card-hover-video');if(v){v.pause();v.currentTime=0;}});
  document.addEventListener('input',e=>{if(e.target.matches('.product-action-wrapper input[name="quantity"]'))updateSubtotal(e.target);});
  document.addEventListener('change',e=>{if(e.target.matches('.product-action-wrapper input[name="quantity"]'))updateSubtotal(e.target);});
  document.addEventListener('click',e=>{const b=e.target.closest('.product-action-wrapper .quantity__button');if(!b)return;const w=b.closest('.product-action-wrapper');requestAnimationFrame(()=>updateSubtotal(w));setTimeout(()=>updateSubtotal(w),60);});
  const refresh=()=>document.querySelectorAll('[data-product-subtotal]').forEach(updateSubtotal);
  document.addEventListener('DOMContentLoaded',refresh);document.addEventListener('shopify:section:load',refresh);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const variant = event?.data?.variant;
      if (!variant) return;
      const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`) || document;
      const subtotal = productInfo.querySelector('[data-product-subtotal]');
      if (subtotal) {
        subtotal.dataset.unitPrice = variant.price;
        updateSubtotal(subtotal);
      }
    });
  }
  new MutationObserver(ms=>{if(ms.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-product-subtotal], product-info')||n.querySelector?.('[data-product-subtotal]')))))refresh();}).observe(document.documentElement,{childList:true,subtree:true});
})();
